(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1673],{

/***/ 1673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content059": function() { return /* binding */ Content059; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87367);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63414);
/* harmony import */ var _Content059_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74656);
/* harmony import */ var _Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Content059 = function(param) {
    var payload = param.payload;
    var ref;
    var description = (ref = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var image = (ref1 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var videoLink = (ref2 = payload === null || payload === void 0 ? void 0 : payload.videoLink) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3;
    var template = (ref3 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref3 !== void 0 ? ref3 : "light";
    var videoId = (0,shared_utils__WEBPACK_IMPORTED_MODULE_5__/* .parseYouTubeId */ .Us)(videoLink);
    var ref4 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useToggle */ .OT)(), opened = ref4.opened, onOpen = ref4.onOpen, onClose = ref4.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper), (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[template]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .ImageLite */ .NH, {
                        image: image,
                        className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                        children: [
                            videoId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .aU, {
                                onClick: onOpen,
                                className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().play),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                        className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        name: "play",
                                        theme: "white"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                value: description,
                                color: "light",
                                className: (_Content059_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description)
                            })
                        ]
                    }),
                    opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .ModalWrapper */ .AB, {
                        onCloseModal: onClose,
                        appearance: "full-area",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .YoutubeVideo */ .tL, {
                            id: videoId
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content059);


/***/ }),

/***/ 74656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grey":"Content059_grey__1MNj5","block":"Content059_block__RuMvv","content":"Content059_content__7gZrr","description":"Content059_description___r1Wr","image":"Content059_image__cvsqk","play":"Content059_play__3GeNR"};

/***/ })

}]);